import React, { useCallback, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IoEyeOutline } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";

import { getQuestionnaireStaffListPath } from "../../../services/config";
import {
  fetchAssAuditStaffData,
  initAuditState,
} from "../../../redux/slices/auditSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { use } from "react";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const AssignedEmployeeList = () => {
  const [searchParams] = useSearchParams()
  const branchId = searchParams.get("branchId");
  const auditModelId = searchParams.get("auditModelId");
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const auditState = useSelector((state) => state.audit);

  const [staffList, setStaffList] = useState([]);

  const getStaffList = useCallback(() => {
    dispatch(
      fetchAssAuditStaffData(
        `${getQuestionnaireStaffListPath(user.user_id, auditModelId, branchId)}`
      )
    );
  });

  useEffect(() => {
    getStaffList();
  }, []);

  useEffect(() => {
    if (auditState.auditAssStaffSuccess || auditState.auditAssStaffError) {
      auditState.auditAssStaffSuccess ? setStaffList(auditState.auditAssStaffData) : toast.error(auditState.auditAssStaffMessage)
    }
  }, [dispatch, auditState]);

  const heading = [
    {
      headerName: "Employee Name",
      field: "full_name",
      flex: 1,
    },

    {
      headerName: "Action",
      width: 200,
      cellRenderer: (rowData) => {
        return (
          <>
            <div className="Branches-table-button">
              <Link to={`/audit-question-list?auditModelId=${auditModelId}&branchId=${branchId}&staffId=${rowData.data.staffId}&staffName=${rowData.data.full_name}`}>
                <IoEyeOutline
                  style={{
                    cursor: "pointer",
                    fontSize: 25,
                    color: "#58d68d",
                    marginRight: "10px",
                  }}
                />
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <div>
      <div className="page-top-bar">
        <div
          style={{
            display: "flex",
            alignItem: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <Link to={"/audit"}>
            <ArrowBackIcon sx={{ scale: 1 }} style={{ color: "gray" }} />
          </Link>
          <h1 style={{ fontSize: "20px", fontWeight: "400" }}>Audit</h1>
        </div>
      </div>
      <div
        className="ag-theme-quartz"
        style={{ height: 575, width: "100%", padding: "0 20px" }}
      >
        <AgGridReact
          rowData={Array.isArray(staffList) ? staffList : []}
          columnDefs={heading}
          omLayout="autoHeight"
          pagination={true}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
        />
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default AssignedEmployeeList;
